import React from 'react'
import PropTypes from 'prop-types'

const ContentStatBlock = ({ label, number }) => {
  const newLabel = number > 1 ? label.concat('s') : label
  return (
    <>
      {number > 0 && (
        <div
          className="bg-gray-100 flex rounded-xl"
          style={{
            minHeight: '90px',
          }}
        >
          <div className="m-auto text-center text-indigo-800">
            <p className="block text-3xl font-bold text-indigo-800 leading-5 mb-1">
              {number}
            </p>
            <p className="text-xl text-indigo-800">{newLabel}</p>
          </div>
        </div>
      )}
    </>
  )
}

ContentStatBlock.propTypes = {
  label: PropTypes.oneOf(['Module', 'Test', 'Lecture', 'File']).isRequired,
  number: PropTypes.number.isRequired,
}

export default ContentStatBlock
